// extracted by mini-css-extract-plugin
module.exports = {"knob":"Knob_knob__2Txiq","indicator":"Knob_indicator__1iLAT"};